import { IFiltroMotoristaModel } from '../model/motorista.model';

/**
 * Contrato de `coluna` enviado ao `POST api/Motorista/Listar` → `spListaMotoristaPopUp`.
 *
 * Colunas 1–5: legado ({@link PesquisaMotoristaComponent} / registro de transações).
 * Colunas 6–8: Autorização manual (este módulo). Ramos na proc em
 * `MOBILIDADE-2922 - Mastercard/scripts/OK/spListaMotoristaPopUp.sql`.
 */
export const MOTORISTA_PESQUISA_AM_COLUNA = {
  matricula: '1',
  apelido: '2',
  cpf: '6',
  celular: '7',
  nome: '8',
} as const;

export type MotoristaPesquisaAmColuna =
  (typeof MOTORISTA_PESQUISA_AM_COLUNA)[keyof typeof MOTORISTA_PESQUISA_AM_COLUNA];

const colunasAutorizacaoManual: readonly MotoristaPesquisaAmColuna[] =
  Object.values(MOTORISTA_PESQUISA_AM_COLUNA);

export function isColunaPesquisaMotoristaAutorizacaoManual(
  coluna: string,
): coluna is MotoristaPesquisaAmColuna {
  return (colunasAutorizacaoManual as readonly string[]).includes(coluna);
}

/** Operador 4 = "Contendo" na UI e na proc. */
export const MOTORISTA_PESQUISA_AM_OPERADOR_CONTENDO = 4;

export function criarFiltroInicialPesquisaMotoristaAutorizacaoManual(
  guid: string,
): IFiltroMotoristaModel {
  return {
    guid,
    coluna: MOTORISTA_PESQUISA_AM_COLUNA.nome,
    operador: MOTORISTA_PESQUISA_AM_OPERADOR_CONTENDO,
    parametro: '',
  };
}

/**
 * Normaliza o parâmetro antes do POST, conforme o tipo de coluna (CPF/celular só dígitos).
 */
export function prepararFiltroMotoristaParaApi(
  filtro: IFiltroMotoristaModel,
): IFiltroMotoristaModel {
  const coluna = filtro.coluna;
  const parametro = (filtro.parametro ?? '').trim();
  if (!parametro) {
    return { ...filtro, parametro: '' };
  }

  switch (coluna) {
    case MOTORISTA_PESQUISA_AM_COLUNA.cpf:
    case MOTORISTA_PESQUISA_AM_COLUNA.celular:
      return { ...filtro, parametro: parametro.replace(/\D/g, '') };
    default:
      return { ...filtro, parametro };
  }
}
